import { useEffect } from "react";
import { createPortal } from "react-dom";
import {
  lockPageScrollForStageModal,
  unlockPageScrollForStageModal,
} from "../../functions/stageRules";

export default function StageCorrectPopup({ open, imageUrl, text }) {
  useEffect(() => {
    if (!open) return undefined;
    lockPageScrollForStageModal();
    return () => unlockPageScrollForStageModal();
  }, [open]);

  if (!open || (!imageUrl && !text)) return null;

  return createPortal(
    <div className="stage-game-popup-overlay" role="dialog" aria-modal="true">
      <div className="stage-game-popup">
        {imageUrl ? (
          <img src={imageUrl} alt="Correct" />
        ) : (
          <p>{text}</p>
        )}
      </div>
    </div>,
    document.body
  );
}
